import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, catchError, of, switchMap, takeUntil } from 'rxjs';
import { Assumptions } from 'src/app/models/UserInfo';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-assumption-settings',
  templateUrl: './assumption-settings.component.html',
  styleUrls: ['./assumption-settings.component.scss']
})
export class AssumptionSettingsComponent implements OnInit {
  assumptionsForm!: FormGroup;
  private destroy$ = new Subject<void>();
  assumptions!: Assumptions;

  constructor(private fb: FormBuilder, private userService: UserService) {
    this.setForm();
  }

  setForm(){
    this.assumptionsForm = this.fb.group({
      ympeProjectionRate: [
        '',
        [
          Validators.required,
          Validators.min(0),
          Validators.max(100),
          this.numberValidator
        ]
      ],
      cppOasProjectionRate: [
        '',
        [
          Validators.required,
          Validators.min(0),
          Validators.max(100),
          this.numberValidator
        ]
      ],
      ITAProjectionRate: [
        '',
        [
          Validators.required,
          Validators.min(0),
          Validators.max(100),
          this.numberValidator
        ]
      ],
      inflationRate: [
        '',
        [
          Validators.required,
          Validators.min(0),
          Validators.max(100),
          this.numberValidator
        ]
      ],
      discountRate: [
        '',
        [
          Validators.required,
          Validators.min(0),
          Validators.max(100),
          this.numberValidator
        ]
      ]
    });
  }

  ngOnInit(): void {
    this.userService.assumptions$
      .pipe(takeUntil(this.destroy$))
        .subscribe((assumptions) => {
          this.assumptions = assumptions;
        });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  numberValidator(control: FormControl) {
    const value = control.value;
    if (isNaN(value)) {
      return { invalidNumber: true };
    }
    return null;
  }

  convertToAssumptions(formData: any): Assumptions {
    return {
        ympeProjectionRate: parseFloat(formData.ympeProjectionRate),
        cppOasProjectionRate: parseFloat(formData.cppOasProjectionRate),
        itaProjectionRate: parseFloat(formData.ITAProjectionRate),
        inflationRate: parseFloat(formData.inflationRate),
        discountRate: parseFloat(formData.discountRate)
    };
  }

  submit(){
    const newAssumptions = this.convertToAssumptions(this.assumptionsForm.value);
    this.userService.insertAssumptionsSettings(newAssumptions)
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      this.userService.setAssumptions(newAssumptions);
      this.setForm();
      this.assumptionsForm.markAsPristine();
      this.assumptionsForm.markAsUntouched();
      this.assumptionsForm.updateValueAndValidity();
    });
  }
}


